import { gql } from '@graphql/__generated__';

export const TRANSLATE_TEXT = gql(/* GraphQL */ `
  query TranslateText($text: String!, $target_language: String!) {
    translate_text(text: $text, target_language: $target_language) {
      text
    }
  }
`);
